import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { __OPERATION__EVENT__ADMIN__ } from 'shell/constants/environment';
import { ItemVM } from 'shell/view-models/item';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { TypeEvent } from 'shell/models/type-event';
import { AxiosResponse } from 'axios';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';
interface TypeEventListComponentProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  onBlur?: () => void;
  error?: boolean;
}

const TypeEventListComponent = ({
  disabled,
  onChange,
  onBlur = () => {
    return;
  },
  value,
  error,
  required,
}: TypeEventListComponentProps): React.ReactElement => {
  const [typeEvents] = useHttpFetch<HttpResponseList<TypeEvent>, Array<ItemVM>>(
    `${__OPERATION__EVENT__ADMIN__}/tipoEvento/list?sort=descrizione`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: (response: AxiosResponse<HttpResponseList<TypeEvent>>) => {
        const data = response.data.payload?.list || [];
        const list = data.map((item: TypeEvent) => ({
          id: item?.codice,
          value: item?.descrizione,
        }));

        return list;
      },
    }
  );

  const typeEventsList = (typeEvents.data as Array<ItemVM>) || [];

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="typeevent-label">
        {required ? 'Tipo Evento *' : 'Tipo Evento'}
      </InputLabel>
      <PmiSelect
        labelId="typeevent-label"
        id="eventCode"
        name="eventCode"
        value={value}
        label={required ? 'Tipo Evento *' : 'Tipo Evento'}
        onChange={onChange}
        disabled={disabled}
        error={error}
        onBlur={onBlur}
      >
        <MenuItem value="">
          <em>Tutti</em>
        </MenuItem>
        {typeEventsList
          ? typeEventsList?.map((item: ItemVM) => (
              <MenuItem key={item.id} value={item.id}>
                {item.value}
              </MenuItem>
            ))
          : undefined}
      </PmiSelect>
    </PmiFormControl>
  );
};

TypeEventListComponent.displayName = 'Type event item component';

const TypeEventList = memo(TypeEventListComponent);

export default TypeEventList as typeof TypeEventListComponent;
